export default __webpack_public_path__ + "static/media/ic_app_store.fe612d18.svg";